import { FormattedMessage, useIntl } from 'react-intl';
import { hideOnError } from '@Util/imageUtils';
import { InlineMarkdown } from '@tlx/astro-shared';

export function PageNotFound() {
    const intl = useIntl();

    return (
        <div className="empty-page">
            <div className="empty-form">
                <img className="empty-page__picture" src="imgs/Error/404-bilde.jpg" alt="" onError={hideOnError} />
                <h1 className="empty-page-title">
                    <FormattedMessage id="text_page_not_found_title" />
                </h1>
                <div className="empty-page-text">
                    <InlineMarkdown>
                        {intl.formatMessage({
                            id: 'text_page_not_found_description_markdown',
                        })}
                    </InlineMarkdown>
                </div>
            </div>
        </div>
    );
}
